export default {
  active_orders: {
    title: 'Commandes actives',
  },
  order_history: {
    title: 'Historique des commandes',
  },
  menu: {
    title: 'Menu',
  },
  printer_settings: {
    title: "Paramètres d'imprimante",
  },
  order_control: {
    title: 'Contrôle des commandes',
  },
  busy_mode: {
    title_zero: 'Mode occupé',
    title_other: 'Mode occupé (+{{time}} min)',
  },
  volume: {
    title: 'Volume',
  },
  switch_language: {
    title: 'Changer de langue ({{language}})',
  },
  logout: {
    title: 'Déconnexion',
    description: 'Êtes-vous sûr de vouloir vous déconnecter ?',
    buttons: {
      confirm: 'Oui',
      cancel: 'Annuler',
    },
  },
  test_restaurant: {
    label: 'Test',
    tooltip: "Restaurant test : ses commandes sont des tests et il n'est jamais facturé.",
  },
};
